(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvOrderTplDeleteController',EnvOrderTplDeleteController);

    EnvOrderTplDeleteController.$inject = ['$uibModalInstance', 'entity', 'EnvOrderTpl'];

    function EnvOrderTplDeleteController($uibModalInstance, entity, EnvOrderTpl) {
        var vm = this;

        vm.tpl = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            EnvOrderTpl.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
